// Project attributes — frontend API surface (merged into @app/services/api).

import { client } from '@platform/http/api-client';

const base = '/api/project-attributes';
const enc = encodeURIComponent;

const projectAttributesApi = {
  // → { attributes: [{ id, name, dataType, description, archived, options: [{ id, value, disabled }] }] }
  async projectAttributesList({ includeArchived = false } = {}) {
    return (await client.get(base, { params: includeArchived ? { includeArchived: 1 } : {} })).data;
  },
  // { name, dataType, description?, options?: [labels] } → the attribute
  async projectAttributeCreate(body) {
    return (await client.post(base, body)).data;
  },
  // { name?, description?, archived? } → the attribute
  async projectAttributeUpdate(id, body) {
    return (await client.patch(`${base}/${enc(id)}`, body)).data;
  },
  async projectAttributeDelete(id) {
    return (await client.delete(`${base}/${enc(id)}`)).data;
  },
  async projectAttributesOrder(attributeIds) {
    return (await client.put(`${base}/order`, { attributeIds })).data;
  },
  async projectAttributeOptionAdd(id, value) {
    return (await client.post(`${base}/${enc(id)}/options`, { value })).data;
  },
  // { value?, disabled? }
  async projectAttributeOptionUpdate(id, optionId, body) {
    return (await client.patch(`${base}/${enc(id)}/options/${enc(optionId)}`, body)).data;
  },
  async projectAttributeOptionDelete(id, optionId) {
    return (await client.delete(`${base}/${enc(id)}/options/${enc(optionId)}`)).data;
  },
  async projectAttributeOptionsOrder(id, optionIds) {
    return (await client.put(`${base}/${enc(id)}/options/order`, { optionIds })).data;
  },
  // → { values: { [spaceId]: { [attributeId]: { value, optionId } } } }
  async projectAttributeValues({ project } = {}) {
    return (await client.get(`${base}/values`, { params: project ? { project } : {} })).data;
  },
  // { [attributeId]: value | null } → { spaceId, values }
  async projectAttributeSetValues(spaceId, patch) {
    return (await client.put(`${base}/values/${enc(spaceId)}`, patch)).data;
  },
};

export default projectAttributesApi;
